import React from "react";
import { Outlet } from "react-router-dom";

function Banks() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default Banks;
